import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    paper: {
        padding: '6px 16px',
        margin: '10px',
        overflow: 'hidden',
        textAlign: 'left'
    },
    mainTitle: {
        maxWidth: '75%',
        textShadow: '1px 1px 2px #000000',
        fontFamily: 'Nunito, sans-serif',
        fontSize: '18px',
        fontWeight: 'Bold',
        margin: '10px 0px',
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    subtitle: {
        fontWeight: 'bold'
    },
    iconBtnContent: {
        height: '32px',
        width: '32px'
    }
}));

export default useStyles;
